import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { Button } from 'react-bootstrap'
import { img } from '@severed-links/common.redherrings-constants'
import { filter, endsWith, replace, trim } from 'lodash'
import * as s from './MainView.scss'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import MobileApps from '../MobileApps/MobileApps'
import { registerLastLoginRole, checkProfile } from '@severed-links/common.redherrings-reducers/account'
import { createNotification } from '@severed-links/common.redherrings-reducers/notifications'

const contestNames = {
    capture: 'Capture',
    cinderella: 'Cinderella',
    terminator: 'Terminator',
    eliminator: 'Eliminator',
    football: 'Football',
    oscars: 'Oscars',
}

const contestDescriptions = {
    capture: 'NCAA tournament contest',
    cinderella: 'Bracket picks and scoreboard',
    terminator: 'Pick a loser. Stay alive.',
    eliminator: 'Survive the NFL season',
    football: 'Weekly NFL picks',
    oscars: 'Academy Awards picks',
}

const MainView = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const roles = useSelector(state => state.account.roles || [])
    const [selectedRole, setSelectedRole] = useState(null)

    useEffect(() => {
        setSelectedRole(null)
        dispatch(checkProfile())
    }, [])
    
    useEffect(() => {
        if (!selectedRole) return undefined
        const timeoutId = setTimeout(() => accessRole(), 650)
        return () => clearTimeout(timeoutId)
    }, [selectedRole])
    
    const selectRole = role => {
        if (selectedRole !== role) {
            setSelectedRole(role)
        } else {
            setSelectedRole(null)
        }
    }

    const accessRole = () => {
        if (selectedRole) {
            dispatch(registerLastLoginRole(`${selectedRole || ''}`))
            .then(action => {
                if (action.payload.messageType === 'success') {
                    const path = `/${replace(selectedRole.toLowerCase(), 'player', '')}`
                    setTimeout(() => navigate(path), 250)
                } else {
                    dispatch(createNotification({
                        type: 'error', 
                        headline: 'Not Authorized', 
                        message: 'You are not authorized to enter the ' + 
                            trim(replace(selectedRole,'Player', '')) + ' area.', 
                        timeout: 6000
                    }))
                    setSelectedRole(null)
                }         
            })
        }
    }

    const contests = [...new Set([...filter(roles, role => endsWith(role, 'Player')), ...(roles.includes('TerminatorAdmin') ? ['TerminatorPlayer'] : [])])]
    const roleIsSelected = !!selectedRole
    return (
        <div className={s.container}>
            <section className={s.hero}>
                <div className={s.heroIcon}><FontAwesomeIcon name='home' /></div>
                <div>
                    <div className={s.eyebrow}>REDHERRINGS</div>
                    <h2>Pick a contest</h2>
                    <p>Choose the contest area you want to enter.</p>
                </div>
            </section>

            <section className={s.contests}>
                <div className={s.sectionHeader}>
                    <h3>Your contests</h3>
                    <span>{contests.length}</span>
                </div>
                <div className={s.contestGrid}>
                {contests && contests.map(c => {
                    const contestKey = replace(c.toLowerCase(), 'player', '')
                    const contestName = contestNames[contestKey] || trim(replace(c, 'Player', ''))
                    const isActive = roleIsSelected && selectedRole === c
                    const isInactive = roleIsSelected && selectedRole !== c
                    return (
                        <Button className={s.contestCard + ' ' + (isActive ? s.active : isInactive ? s.inactive : '') + ' ' + s[contestKey]} key={`main-view-contest-${c}`}
                            style={{ backgroundImage: 'url(' + (c === 'TerminatorPlayer' ? img.CloudinaryBaseUrl + 'terminator/header_terminator_mobile.png' : img.CloudinaryBaseUrl + img[c.replace('Player', '') + 'HeaderMobile']) + ')' }}
                            disabled={isInactive}
                            aria-label={`Enter ${contestName}`}
                            onClick={() => selectRole(c)}>
                            <span className={s.cardContent}>
                                <span className={s.cardTitle}>{contestName}</span>
                                <span className={s.cardDetail}>{isActive ? <>Opening <FontAwesomeIcon name='circle-notch' spin /></> : contestDescriptions[contestKey]}</span>
                            </span>
                        </Button>
                    )
                })}
                {!contests.length ? <div className={s.emptyState}>No contests are available for this account.</div> : null}
                </div>
            </section>

            <section className={s.appsPanel}>
                <MobileApps />
            </section>
        </div>
    )
}

export default MainView
